import { useContext } from 'react';
import { parse } from 'url';

import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext.ts';

import {
	MOBILE_APP_WITH_EDITING_QUERY_PARAM_VALUES,
	MOBILE_APP_WITH_COMMENTING_QUERY_PARAM_VALUES,
	MOBILE_APP_QUERY_PARAM_VALUES,
	checkForValidParam,
} from '@confluence/mobile-app-detection-common';

export const useIsMobileApp = (
	uri?: string,
): {
	isMobileApp: boolean;
	isMobileAppWithCommenting: boolean;
	isMobileAppWithEditing: boolean;
} => {
	const { location, getQueryParams } = useContext(RoutesContext);
	let { parentProduct = '', presentationMode = '' } = getQueryParams();

	// If we have a uri string, we are being asked to check the query params from the uri
	if (uri) {
		({ parentProduct = '', presentationMode = '' } = parse(uri, true)?.query ?? {});
	} else if (location === null) {
		// If the RoutesContext is not available, we need to parse the query params from window.location
		({ parentProduct = '', presentationMode = '' } =
			parse(window?.location?.search, true)?.query ?? {});
	}

	return {
		isMobileApp:
			checkForValidParam(presentationMode, MOBILE_APP_QUERY_PARAM_VALUES) ||
			checkForValidParam(parentProduct, MOBILE_APP_QUERY_PARAM_VALUES),
		isMobileAppWithCommenting:
			checkForValidParam(presentationMode, MOBILE_APP_WITH_COMMENTING_QUERY_PARAM_VALUES) ||
			checkForValidParam(parentProduct, MOBILE_APP_WITH_COMMENTING_QUERY_PARAM_VALUES),
		isMobileAppWithEditing:
			checkForValidParam(presentationMode, MOBILE_APP_WITH_EDITING_QUERY_PARAM_VALUES) ||
			checkForValidParam(parentProduct, MOBILE_APP_WITH_EDITING_QUERY_PARAM_VALUES),
	};
};
